<template>
     <el-dialog title="应收/应付审批" :visible.sync="pageShow" width="30%">
          <div class="auditForm">
               <el-form ref="formRef" :model="formData" label-width="80px">
                    <el-form-item label="审核状态">
                         <el-radio-group v-model="formData.status">
                              <el-radio :label="item.value" v-for="item in statusArr" :key="item.value">{{item.label}}</el-radio>
                         </el-radio-group>
                    </el-form-item>
                    <el-form-item label="备注" v-if="formData.status == 2">
                         <el-input type="textarea" v-model="formData.remark"></el-input>
                    </el-form-item>
               </el-form>
          </div>
          <span slot="footer" class="dialog-footer">
               <el-button @click="cancel">取 消</el-button>
               <el-button type="primary" @click="save">确 定</el-button>
          </span>
     </el-dialog>
</template>

<script>
export default {
     data() {
          return {
               pageShow: false,
               statusArr:[
                    // {value:0,label:"申请中"},
                    {value:1,label:"已审核"},
                    {value:2,label:"审核失败"},
               ],
               formData: {
                    status:1,
                    remark: ''
               },
               curId:''
          }
     },
     methods: {
          open(options) {
               console.log('open',options)
               this.curId=options.id;
               this.pageShow = true;
          },
          close() {
               this.pageShow = false;
          },
          cancel() { this.close(); },
          save() {
               if(this.formData.status == 1){
                    this.formData.remark='';
               }
               console.log('formData',this.formData);
               this.$emit('ok',{id:this.curId,data:this.formData})
               this.pageShow = false;
          }
     },
}
</script>

<style lang="scss" scoped></style>